/* import __COLOCATED_TEMPLATE__ from './client-edit.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { alias } from '@ember/object/computed';

export default Component.extend({
  intercomEventService: service(),
  useOAuthFlow: alias('appPackage.changeRequest.appPackageConfig.oauthClient.useOAuthFlow'),
  actions: {
    toggleOauthClient() {
      this.toggleProperty('useOAuthFlow');
    },
  },
});
